import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
dayjs.extend(isToday);
export const getFormatedDate = (date) => {
    if (dayjs(date).isToday()) {
        return dayjs(date).format('H:mma');
    }
    return dayjs(date).format('MMM D');
};
